import React from 'react';

import './styles.css';
import { FaTrash } from 'react-icons/fa';

import trainingsServices from '../../../../../services/academy/trainingsServices';

export default function ClassTrainingsCardItem(props) {
    async function deleteTraining() {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja excluir o treino?`)) {
            const response = await trainingsServices.deleteTraining(props.classId, props.id);
            if (response.status === 204) {
                props.onDelete(props.index);
            } else
                alert("Erro ao excluir treino, tente novamente!");
        }
    }

    return (
        <li className='class-card-trainings-list-item'>
            <div className='class-card-trainings-component'>
                <div>
                    {props.day ? <p className='day'>{props.day}</p> : <p>Dia não definido</p>}
                    <p className='time'>
                        {
                            props.start && props.end ?
                                `Das ${props.start} às ${props.end}`
                                : 'Hora não definida'
                        }
                    </p>
                </div>
                {props.game ? <span className='practice-game'><p>Jogo</p></span> : []}
                <span><p>{props.frequency}</p></span>
            </div>
            {
                props.canDelete ?
                    <button className='red' onClick={deleteTraining}><FaTrash /></button>
                    : []
            }
        </li>
    )
}